import { render, staticRenderFns } from "./ScrollOptions.vue?vue&type=template&id=11b74f48&scoped=true&"
import script from "./ScrollOptions.vue?vue&type=script&lang=js&"
export * from "./ScrollOptions.vue?vue&type=script&lang=js&"
import style0 from "./ScrollOptions.vue?vue&type=style&index=0&id=11b74f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b74f48",
  null
  
)

export default component.exports